module.exports = __webpack_public_path__ + "img/Trinkwasserversorgung.5e49b0dc.svg";